
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-home-page",
      function () {
        return require("private-next-pages/new-home-page.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-home-page"])
      });
    }
  